import 'videojs-event-tracking';

export default {};
